import { StoreService } from '@ecm/dispatcher';

export class PropertiesUtils {
    /**
     * Current contract key
     * @type {string}
     */
    private static readonly CURRENT_CONTRACT_KEY: string = 'currentContract';

    /**
     * Sosh brand name
     * @type {string}
     */
    private static readonly SOSH_BRAND_LABEL: string = 'Sosh';

    /**
     * Check if current contract has sosh brand
     * @returns {boolean}
     */
    public static isSoshBrand(): boolean {
        let isSosh = false;
        if (StoreService.has(PropertiesUtils.CURRENT_CONTRACT_KEY)) {
            const storedContract: any = StoreService.get(PropertiesUtils.CURRENT_CONTRACT_KEY);
            if (storedContract && storedContract.brand) {
                isSosh = storedContract.brand === PropertiesUtils.SOSH_BRAND_LABEL;
            }
        }
        return isSosh;
    }
}
